import { combineActions, handleActions } from 'redux-actions'

import _ from 'lodash'

import { selectGalleryItem, selectReadonlyGalleryItem } from '@tabeeb/modules/gallery/actions'

import * as annotationsActions from '../actions'

const defaultState = []

export default handleActions(
  {
    [annotationsActions.setHiddenAnnotationsIds](state, action) {
      const annotationId = action.payload

      return annotationId
    },
    [annotationsActions.addAnnotationsToHidden](state, action) {
      const annotationIds = action.payload

      return _.uniqBy([...state, ...annotationIds])
    },
    [annotationsActions.removeAnnotationsFromHidden](state, action) {
      const annotationIds = new Set(action.payload)

      return state.filter((id) => !annotationIds.has(id))
    },
    [combineActions(
      selectGalleryItem,
      selectReadonlyGalleryItem,
      annotationsActions.resetAnnotationsState,
      annotationsActions.resetHiddenAnnotationsIds
    )](state, action) {
      return defaultState
    },
  },
  defaultState
)
